export const PAYMENTS_LOCATION_STORAGE_KEY = 'paymentsLocationFilter';

export interface PaymentsLocationOption {
  value: string;
  label: string;
  stripeAccountId?: string;
}

export function mapLocationsForPaymentsFilter(locations: { id?: string; branch?: string; stripe_account_id?: string }[]): PaymentsLocationOption[] {
  return (locations || [])
    .filter(loc => Boolean(loc?.id))
    .map(loc => ({
      value: String(loc.id),
      label: loc.branch?.trim() || 'Location',
      stripeAccountId: loc.stripe_account_id?.trim() || undefined
    }));
}

function resolveSelectedLocationOption(
  selectedLocationId: string,
  locationOptions: PaymentsLocationOption[]
): PaymentsLocationOption | undefined {
  if (!selectedLocationId) {
    return undefined;
  }
  return locationOptions.find(opt => opt.value === selectedLocationId);
}

export function resolvePaymentsLocationLabel(
  selectedLocationId: string,
  locationOptions: PaymentsLocationOption[]
): string {
  if (!selectedLocationId) {
    return 'All Locations';
  }
  return resolveSelectedLocationOption(selectedLocationId, locationOptions)?.label ?? 'All Locations';
}

export function buildPaymentsLocationApiFilters(
  selectedLocationId: string,
  locationOptions: PaymentsLocationOption[]
): { locationId?: string; stripeAccountId?: string } {
  if (!selectedLocationId) {
    return {};
  }
  const match = resolveSelectedLocationOption(selectedLocationId, locationOptions);
  return {
    locationId: selectedLocationId,
    ...(match?.stripeAccountId ? { stripeAccountId: match.stripeAccountId } : {})
  };
}
